// extracted by mini-css-extract-plugin
module.exports = {"sidebarPaper":"styles_sidebarPaper__2pP04","dataItem":"styles_dataItem__3USP-"};